import { Select, Tooltip } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const TitleLabel = styled.div`
  padding: 10px 0;
`;

export const SelectControl = styled(Select)`
  padding: 10px, 0px, 10px, 0px;
  width: 100%;
`;

export const NameStrong = styled.strong``;

export const ColorBlue = styled.div`
  color: #096dd9;
  min-height: 1px;
  max-height: 2px;
  margin-top: 1%;
  @media (max-width: 815px) {
    margin-bottom: 5%;
  }
`;

export const TooltipIcon = styled(Tooltip)`
  margin-left: 4px;
`;

export const EditQtdIcon = styled.span`
  position: absolute;
  margin-left: 90%;
  margin-top: -10%;
  background-color: none;
`;